module.exports = __webpack_public_path__ + "static/img/101801.1c64d6e3.png";